import { createField, newEmailField, newPasswordField, requiredStringField } from '@utils/forms';
import * as t from 'io-ts';

export class StaffFormFields {
  static instance: StaffFormFields | undefined;

  static get shared() {
    if (StaffFormFields.instance === undefined) {
      StaffFormFields.instance = new StaffFormFields();
    }
    return StaffFormFields.instance;
  }

  employeeId = createField((label) => requiredStringField(label, 1, 32), 'employeeId', {
    ja: '社員ID',
  });

  displayName = createField((label) => requiredStringField(label, 1, 128), 'displayName', {
    ja: '名前',
  });

  firstName = createField((label) => requiredStringField(label, 1, 128), 'firstName', {
    ja: '名',
  });

  lastName = createField((label) => requiredStringField(label, 1, 128), 'lastName', {
    ja: '姓',
  });

  email = createField((label) => newEmailField(label), 'email', {
    ja: 'メール',
  });

  password = createField((label) => newPasswordField(label), 'password', {
    ja: 'パスワード',
  });

  role = createField((label) => requiredStringField(label, 1, 128), 'role', {
    ja: '権限グループ',
  });

  toCreateStaffSchema() {
    return t.type({
      staff_id: this.employeeId.type,
      first_name: this.firstName.type,
      last_name: this.lastName.type,
      email: this.email.type,
      role: this.role.type,
      password: this.password.type,
      become_member: t.array(t.string),
    });
  }

  toCreateStaffInitialValue(): t.TypeOf<ReturnType<StaffFormFields['toCreateStaffSchema']>> {
    return {
      staff_id: '',
      first_name: '',
      last_name: '',
      role: 'admin',
      email: '',
      password: '',
      become_member: ['Y'],
    };
  }
}
